import { IMAGE_FORMATS, VIDEO_FORMATS } from "./constants";

const ASSET_FILE_EXTENSIONS = new Set(
  [...IMAGE_FORMATS, ...VIDEO_FORMATS].map((extension) =>
    extension.toLowerCase()
  )
);

const PNG_ASSET_CHECKER_LIGHT = "#ffffff";
const PNG_ASSET_CHECKER_DARK = "#c8c8c8";
const PNG_ASSET_CHECKER_SIZE = 12;

export const PNG_ASSET_BACKDROP_SX = {
  backgroundColor: PNG_ASSET_CHECKER_LIGHT,
  backgroundImage: `repeating-conic-gradient(${PNG_ASSET_CHECKER_DARK} 0% 25%, ${PNG_ASSET_CHECKER_LIGHT} 0% 50%)`,
  backgroundSize: `${PNG_ASSET_CHECKER_SIZE}px ${PNG_ASSET_CHECKER_SIZE}px`,
};

export const isPngAssetExtension = ({ extension = "" } = {}) =>
  String(extension).toLowerCase() === "png";

export const stripAssetFileExtension = ({ name = "" }) => {
  const trimmed = String(name).trim();
  if (!trimmed) return "";

  const lastDotIndex = trimmed.lastIndexOf(".");
  if (lastDotIndex <= 0) return trimmed;

  const extension = trimmed.slice(lastDotIndex + 1).toLowerCase();
  if (!ASSET_FILE_EXTENSIONS.has(extension)) return trimmed;

  return trimmed.slice(0, lastDotIndex).trim();
};

const getFileNameFromUrl = ({ url = "" }) => {
  try {
    const pathname = new URL(url).pathname;
    const segment = pathname.split("/").pop() || "";
    return decodeURIComponent(segment.split("?")[0]) || "";
  } catch {
    const segment = url.split("/").pop() || "";
    return decodeURIComponent(segment.split("?")[0]) || "";
  }
};

export const getAssetDisplayName = ({ item }) => {
  const storedName = stripAssetFileExtension({ name: item?.name });
  if (storedName) return storedName;

  if (!item?.url) return "";

  return stripAssetFileExtension({
    name: getFileNameFromUrl({ url: item.url }),
  });
};
